import axios from 'axios';
import apiConfig from '../api.config';

export default function policeReportValidateFileExportS3(data) {
  const {
    host,
    URIs: { policeReportValidateFileExportS3 },
  } = apiConfig;

  const uri = `${host}${policeReportValidateFileExportS3}`;

  return axios
    .post(uri, data)
    .then(res => {
      return res.data;
    });
}
